import { ClientSettings } from '@badgateway/oauth2-client/dist/client';
import { Environment } from '../../types/Environment';

export const oauth2ClientCredentials: Record<Environment, ClientSettings> = {
  [Environment.Local]: {
    server: 'http://localhost:8303',
    clientId: '984e1592-de85-486e-a28b-05bfdaa16559',
    clientSecret: 'ayo4ahnaiFah0Tain4uuQuie7zae0Bee',
    tokenEndpoint: '/oauth2/token',
  },
  [Environment.LocalUtveckling]: {
    server: 'https://legoasutv01.prodstod.se',
    clientId: 'ef67a698-f90c-4842-a88e-0f6861b80db1',
    clientSecret: 'deo0gee9Xoo0xeegh8iequahpooth8ee',
    tokenEndpoint: '/fsok/oauth2/token',
  },
  [Environment.Utveckling]: {
    server: window.location.origin,
    clientId: 'ef67a698-f90c-4842-a88e-0f6861b80db1',
    clientSecret: 'deo0gee9Xoo0xeegh8iequahpooth8ee',
    tokenEndpoint: '/fsok/oauth2/token',
  },
  [Environment.Acceptans]: {
    server: window.location.origin,
    clientId: '091cb996-25b5-47c1-b04c-eb644b8c0327',
    clientSecret: 'ay5ahwa4umeiP7oochoojie7Ait9feim',
    tokenEndpoint: '/fsok/oauth2/token',
  },
  [Environment.Stage]: {
    server: window.location.origin,
    clientId: '2addc6ea-603a-418b-804c-dc38513f706e',
    clientSecret: 'emeLae0eiVai4Ohgh1EiRae5bah1Aeni',
    tokenEndpoint: '/fsok/oauth2/token',
  },
  [Environment.Prod]: {
    server: window.location.origin,
    clientId: '3b2c19ae-dbfb-43b9-ada5-06265a77611a',
    clientSecret: 'shee5eew4bahthaiN2xair1eiDiiyaeb',
    tokenEndpoint: '/fsok/oauth2/token',
  },
};
